import { inject } from '@angular/core';
import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { AuthService } from './auth.service';

export const authInterceptorFn: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const authService = inject(AuthService);

  if (request.url.includes('dictionary/v3')){
    const tokenReq = request.clone({
      setHeaders: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });

    return next(tokenReq);
  }

  return next(request);
};
